import { JetView } from 'webix-jet'; // Importing the JetView class from the webix-jet library for creating views.
import GeoView from 'views/customers/geo'; // Importing GeoView component for geographical representation of customer data.
import MoneyView from 'views/agent/statistics/money'; // Importing MoneyView component for displaying financial statistics.
import MarketingView from 'views/agent/statistics/marketing'; // Importing MarketingView component for marketing statistics.
import MarketingVsRegistrosView from 'views/agent/statistics/marketingvsregistros'; // Importing component for comparing marketing statistics with records.
import StatAgeView from 'views/agent/statistics/age'; // Importing StatAgeView component for age-related statistics.
import PositionsView from 'views/customers/positions'; // Importing PositionsView component for displaying customer positions.
import { devConfig } from '../../config/config'; // Importing development configuration settings from the config file.

export default class StatisticsView extends JetView {
    // Defining the StatisticsView class that extends JetView.
    /**
     * Configures the UI layout and components for the statistics dashboard.
     * @returns {Object} The configuration object for the UI layout.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        var toDateLocal = // Variable to hold the current date and time in local format
            new Date().getFullYear() +
            ':' +
            ('00' + (new Date().getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + new Date().getDate()).slice(-2) +
            ' ' +
            ('00' + new Date().getHours()).slice(-2) +
            ':' +
            ('00' + new Date().getMinutes()).slice(-2) +
            ':' +
            ('00' + new Date().getSeconds()).slice(-2);
        var fromDateLocal; // Variable to hold the starting date for the date range
        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            rows: [
                {
                    view: 'toolbar', // Toolbar for date selection buttons
                    paddingY: 2,
                    cols: [
                        {
                            view: 'button', // Button for selecting today's date
                            value: _('Hoy'), // Localized button label
                            click: () => {
                                fromDateLocal = // Calculate the date for 'Hoy'
                                    webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), 0, 'day').getSeconds()).slice(-2);
                                const dateFilter = { // Object to hold the date filter parameters
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Hoy',
                                };
                                console.log(dateFilter); // Log the date filter for debugging
                                this.app.callEvent('statisticsAgent:date', [dateFilter]); // Trigger event with date filter
                            },
                        },
                        {
                            view: 'button', // Button for selecting yesterday's date
                            value: _('Ayer'), // Localized button label
                            click: () => {
                                fromDateLocal = // Calculate the date for 'Ayer'
                                    webix.Date.add(new Date(), -1, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -1, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -1, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ayer',
                                };
                                console.log(dateFilter); // Log the date filter for debugging
                                this.app.callEvent('statisticsAgent:date', [dateFilter]); // Trigger event with date filter
                            },
                        },
                        {
                            view: 'button', // Button for selecting the last 3 days
                            value: _('Ultimos 3 días'), // Localized button label
                            click: () => {
                                fromDateLocal = // Calculate the date for 'Ultimos 3 días'
                                    webix.Date.add(new Date(), -3, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -3, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -3, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ultimos 3 días',
                                };
                                console.log(dateFilter); // Log the date filter for debugging
                                this.app.callEvent('statisticsAgent:date', [dateFilter]); // Trigger event with date filter
                            },
                        },
                        {
                            view: 'button', // Button for selecting the last 7 days
                            value: _('Ultimos 7 días'), // Localized button label
                            click: () => {
                                fromDateLocal = // Calculate the date for 'Ultimos 7 días'
                                    webix.Date.add(new Date(), -7, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -7, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -7, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ultimos 7 días',
                                };
                                console.log(dateFilter); // Log the date filter for debugging
                                this.app.callEvent('statisticsAgent:date', [dateFilter]); // Trigger event with date filter
                            },
                        },
                        {
                            view: 'button', // Button for selecting the last 30 days
                            value: _('Ultimos 30 días'), // Localized button label
                            click: () => {
                                fromDateLocal = // Calculate the date for 'Ultimos 30 días'
                                    webix.Date.add(new Date(), -30, 'day').getFullYear() +
                                    ':' +
                                    ('00' + (webix.Date.add(new Date(), -30, 'day').getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getHours()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + webix.Date.add(new Date(), -30, 'day').getSeconds()).slice(-2);
                                const dateFilter = {
                                    FromDateLocal: fromDateLocal,
                                    ToDateLocal: toDateLocal,
                                    day: 'Ultimos 30 días',
                                };
                                console.log(dateFilter); // Log the date filter for debugging
                                this.app.callEvent('statisticsAgent:date', [dateFilter]); // Trigger event with date filter
                            },
                        },
                        {
                            view: 'form', // Form for date range selection
                            class: 'date-dashboard', // CSS class for styling
                            id: 'myform', // Unique identifier for the form
                            type: 'clean', // Form type
                            height: 30, // Height of the form
                            elements: [
                                {
                                    view: 'daterangepicker', // Date range picker component
                                    name: 'regDateRange', // Name for the date range
                                    id: 'fechaRango', // Unique identifier for the date range picker
                                    placeholder: _('Seleccione Fecha'), // Placeholder text
                                    format: webix.Date.dateToStr('%d %M %Y'), // Date format for display
                                },
                            ],
                            padding: 0, // Padding for the form
                        },
                    ],
                },
                {
                    type: 'wide', // Container type for layout
                    rows: [
                        {
                            gravity: 2, // Gravity for layout distribution
                            type: 'wide', // Container type for layout
                            cols: [
                                MarketingView, // First column with MarketingView component
                                { view: 'resizer' }, // Resizer component for adjustable layout
                                {
                                    type: 'wide', // Container type for layout
                                    minWidth: 370, // Minimum width for the column
                                    rows: [MarketingVsRegistrosView], // Second column with MarketingVsRegistrosView component
                                },
                            ],
                        },
                        {
                            type: 'wide', // Container type for layout
                            cols: [MoneyView, { view: 'resizer' }, StatAgeView], // Third column with MoneyView and StatAgeView components
                        },
                    ],
                    ready: function () {}, // Placeholder for ready function
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up any necessary data or event handlers.
     */
    init() {
        // Preserve the context of 'this' for use in nested functions
        var initThis = this;
        // Retrieve the current user parameter from the application context
        const cur_user = this.getParam('user', true);
        // Listen for the 'statisticsAgent:date' event to trigger data fetching
        this.on(this.app, 'statisticsAgent:date', (date) => {
            // Store the date range received from the event
            var dateRange = date;
            // Make an AJAX POST request to fetch marketing statistics
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set the content type for the request
                })
                .post(
                    devConfig.geturlApi() + 'Agent/GetMarketingStats', // API endpoint for fetching stats
                    '{ "AgentId":' +
                        cur_user + // Include the current user ID in the request
                        ', "FromDateLocal":"' +
                        dateRange.FromDateLocal + // Start date for the statistics
                        '", "ToDateLocal":"' +
                        dateRange.ToDateLocal + // End date for the statistics
                        '"}',
                    {
                        // Handle error response from the API
                        error: function (text, data, XmlHttpRequest) {
                            webix.message(_('Error! ')); // Display an error message
                        },
                        // Handle successful response from the API
                        success: function (text, data, XmlHttpRequest) {
                            var data = JSON.parse(text); // Parse the JSON response
                            // Trigger events with the fetched marketing statistics
                            initThis.app.callEvent(
                                'statisticsAgent:marketing',
                                [data.result.charts.MediaStat.records], // Media statistics
                            );
                            initThis.app.callEvent('statisticsAgent:marketingvsregistros', [
                                data.result.charts.MarketingVsRegistros.records, // Marketing vs Registrations statistics
                            ]);
                            initThis.app.callEvent(
                                'statisticsAgent:MoneyUsers',
                                [data.result.charts.MoneyUsers.records], // Money users statistics
                            );
                            initThis.app.callEvent(
                                'statisticsAgent:ageUsersStat',
                                [data.result.charts.AgeUsers.records], // Age users statistics
                            );
                        },
                    },
                );
        });
        // Attach an event listener to the popup for when it is hidden
        this.$$('fechaRango')
            .getPopup()
            .attachEvent('onhide', function () {
                // Retrieve the date range values from the form
                const dateRange = initThis.$$('myform').getValues();
                // Format the start date into a local string
                var fromDateLocal =
                    dateRange.regDateRange.start.getFullYear() +
                    ':' +
                    ('00' + (dateRange.regDateRange.start.getMonth() + 1)).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.start.getDate()).slice(-2) +
                    ' ' +
                    ('00' + dateRange.regDateRange.start.getHours()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.start.getMinutes()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.start.getSeconds()).slice(-2);
                // Format the end date into a local string
                var toDateLocal =
                    dateRange.regDateRange.end.getFullYear() +
                    ':' +
                    ('00' + (dateRange.regDateRange.end.getMonth() + 1)).slice(-2) +
                    ('00' + dateRange.regDateRange.end.getDate()).slice(-2) +
                    ' ' +
                    ('00' + dateRange.regDateRange.end.getHours()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.end.getMinutes()).slice(-2) +
                    ':' +
                    ('00' + dateRange.regDateRange.end.getSeconds()).slice(-2);
                // Create an object to hold the formatted date range
                const dateFilter = {
                    FromDateLocal: fromDateLocal, // Start date
                    ToDateLocal: toDateLocal, // End date
                };
                // Trigger the 'statisticsAgent:date' event with the formatted date range
                initThis.app.callEvent('statisticsAgent:date', [dateFilter]);
            }); // Placeholder for the initialization content of the view.
    }
}

// FILE DOCUMENTED
